<template>
  <v-card outlined rounded="lg" :loading="loading" class="pa-3">
    <div class="section-card-title">
      <v-icon color="#B3151B" class="mr-2">mdi-school</v-icon>
      ข้าราชการครูและบุคลากรทางการศึกษา แยกตามวิทยฐานะ
      <span class="section-card-count">{{ numberWithCommas(countAll) }} คน</span>
    </div>

    <v-row>
      <v-col cols="12" md="5">
        <apexchart v-if="!loading && countAll > 0" type="donut" height="280" :options="chartOptions" :series="series"></apexchart>
      </v-col>
      <v-col cols="12" md="7">
        <v-data-table :items="college_rang" :headers="header" :search="search" dense>
          <template v-slot:top>
            <v-text-field v-model="search" label="ค้นหา" prepend-icon="mdi-magnify" dense outlined hide-details class="mb-3"></v-text-field>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
// ข้อมูลข้าราชการครูฯ แยกตามวิทยฐานะ — มาจากระบบ HRvec_openapi กลาง (เหตุผลเดียวกับ manPowerHrvec.vue)
export default {
  name: "DashboardOvecMasterCollegeRang",

  data() {
    return {
      search: "",
      loading: true,
      college_rang: [],
      header: [
        { text: "วิทยาลัย", align: "left", value: "college_rang_name" },
        { text: "ข้าราชการ", align: "center", value: "college_rang_all" },
        { text: "ครูผู้ช่วย", align: "center", value: "college_rang_0" },
        { text: "คศ.1", align: "center", value: "college_rang_1" },
        { text: "คศ.2", align: "center", value: "college_rang_2" },
        { text: "คศ.3", align: "center", value: "college_rang_3" },
        { text: "คศ.4", align: "center", value: "college_rang_4" },
        { text: "คศ.5", align: "center", value: "college_rang_5" }
      ],
      series: [],
      chartOptions: { chart: { type: "donut" } },
      countAll: 0
    };
  },

  async mounted() {
    await this.college_rang_Qid();
  },

  methods: {
    numberWithCommas(x) {
      x = String(x);
      const pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },

    async college_rang_Qid() {
      try {
        this.loading = true;
        let result = await this.$http.post("college_rang_id.php", { college_id: this.college_ID });
        this.college_rang = Array.isArray(result.data) ? result.data : [];
        const data = this.college_rang;

        let counts = [0, 0, 0, 0, 0, 0];
        data.forEach(value => {
          for (let i = 0; i < 6; i++) counts[i] += parseInt(value["college_rang_" + i]) || 0;
        });

        // ผลรวมหัวเรื่องต้องมาจากการรวมตามประเภทตำแหน่ง (college_rang_0..5) ที่แสดงในกราฟ/ตารางจริง
        // ไม่ใช่ค่า college_rang_all ที่เก็บแยกไว้ต่างหาก ซึ่งพบว่าไม่ตรงกับผลรวมตามประเภทตำแหน่ง
        this.countAll = counts.reduce((a, b) => a + b, 0);
        this.series = counts;

        const labels = ["ครูผู้ช่วย", "ครู", "ชำนาญการ", "ชำนาญการพิเศษ", "เชี่ยวชาญ", "เชี่ยวชาญพิเศษ"];
        this.chartOptions = {
          chart: { type: "donut" },
          labels: labels.map((l, i) => l + " : " + this.numberWithCommas(counts[i])),
          colors: ["#B3151B", "#1B365D", "#A86400", "#424242", "#8E1014", "#9E9E9E"],
          legend: { position: "bottom", fontFamily: "Kanit" }
        };

        this.$emit("loaded", { rows: data, countAll: this.countAll, byRank: counts });
      } catch (error) {
        this.$emit("loaded", null);
      } finally {
        this.loading = false;
      }
    }
  },

  computed: {
    college_ID() {
      return this.$route.query.college_ID;
    }
  }
};
</script>

<style scoped>
.section-card-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-weight: 700;
  color: #1b365d;
  font-size: 1rem;
  margin-bottom: 8px;
}
.section-card-count {
  margin-left: auto;
  font-weight: 700;
  color: #b3151b;
}
</style>
